export default __webpack_public_path__ + "static/media/central_andes_2_21.9cd441b7.JPG";